export default "__VITE_ASSET__lwiv5pvU__"